/**
 * Streaming SSE client for /api/ai/analyze and /api/ai/chat.
 * Uses fetch + ReadableStream to parse `data: {...}\n\n` events.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function streamAi(path, body, { onDelta, onDone, onError, signal }) {
  try {
    const res = await fetch(`${API}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal,
    });
    if (!res.ok) {
      const t = await res.text().catch(() => "");
      throw new Error(`HTTP ${res.status}: ${t}`);
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const events = buffer.split("\n\n");
      buffer = events.pop() || "";
      for (const ev of events) {
        const line = ev.trim();
        if (!line.startsWith("data:")) continue;
        const payload = line.replace(/^data:\s*/, "");
        try {
          const parsed = JSON.parse(payload);
          if (parsed.delta) onDelta?.(parsed.delta);
          if (parsed.error) onError?.(new Error(parsed.error));
          if (parsed.done) {
            onDone?.();
            return;
          }
        } catch (e) {
          // skip malformed
        }
      }
    }
    onDone?.();
  } catch (err) {
    if (err.name === "AbortError") return;
    onError?.(err);
  }
}

export const analyzeStream = (scope, opts) =>
  streamAi("/ai/analyze", { scope }, opts);

export const chatStream = (payload, opts) =>
  streamAi("/ai/chat", payload, opts);
